<template>
  <top-nav>
    <template>
      <template v-if="list_agents">
        <li>
          <router-link :to="{name: 'wallet.agent.topup'}">
            Agent Wallet TopUp
          </router-link>
        </li>
        <li>
          <router-link :to="{name: 'wallet.agent.transactions'}">
            Agent Wallet Transactions
          </router-link>
        </li>
      </template>
      <template v-if="$store.getters.getAuthUser.role !== 'agent'">
        <li>
          <router-link :to="{ name: 'wallet.topup'}">
            TopUp Wallet
          </router-link>
        </li>
        <li>
          <router-link :to="{name: 'wallet.transactions'}">
            Wallet Transactions
          </router-link>
        </li>
        <li v-if="$store.getters.getAuthUser.role == 'customer'">
          <router-link :to="{name: 'wallet.list'}">
            View Company Wallets
          </router-link>
        </li>
      </template>
    </template>
  </top-nav>
</template>
<script>
    import TopNav from "@/components/TopNav.vue";

    export default {
        components: {
            TopNav
        },
        computed: {
            list_agents() {
                return this.$can.view(this.$store.getters.getAuthUser, 'list-agents-owned') || this.$can.view(this.$store.getters.getAuthUser, 'list-agents');
            }
        }
    }
</script>



